/* eslint-disable max-len */

const Dates2026 = Object.freeze({
  INIT: '1996/01/01',
  END: '2008/12/31',
  ERROR_DATE: 'Fecha de nacimiento fuera del rango. Solo podrán beneficiarse de esta subvención los jóvenes nacidos entre el 1 de enero de 1996 y el 31 de diciembre de 2008.',
  ERROR_DATE_CODIGO: 'Fecha de nacimiento fuera del rango. Solo podrán beneficiarse de esta subvención los jóvenes nacidos entre el 1 de enero de 2000 y el 31 de diciembre de 2011.',
  ERROR_DATE_TUTOR: 'Fecha de nacimiento fuera del rango. Solo podrán realizar el registro del menor los tutores mayores a 14 años.',
  ERROR_DATE_MINOR: 'Fecha de nacimiento fuera del rango. Solo podrán beneficiarse de esta subvención los jóvenes nacidos entre el 1 de enero de 2012 y el 31 de diciembre de 2026.',
  INIT_CODIGO: '2000/01/01',
  END_CODIGO: '2011/12/31',
  INIT_CODIGO_MINOR: '2012/01/01',
  END_CODIGO_MINOR: '2026/12/31',
  MAYOR_16: '2009/12/31',
  MINOR_120: '1900/01/01',
});

const Dates2025 = Object.freeze({
  INIT: '1995/01/01',
  END: '2007/12/31',
  ERROR_DATE: 'Fecha de nacimiento fuera del rango. Solo podrán beneficiarse de esta subvención los jóvenes nacidos entre el 1 de enero de 1995 y el 31 de diciembre de 2007.',
  ERROR_DATE_CODIGO: 'Fecha de nacimiento fuera del rango. Solo podrán beneficiarse de esta subvención los jóvenes nacidos entre el 1 de enero de 1999 y el 31 de diciembre de 2010.',
  ERROR_DATE_TUTOR: 'Fecha de nacimiento fuera del rango. Solo podrán realizar el registro del menor los tutores mayores a 14 años.',
  ERROR_DATE_MINOR: 'Fecha de nacimiento fuera del rango. Solo podrán beneficiarse de esta subvención los jóvenes nacidos entre el 1 de enero de 2011 y el 31 de diciembre de 2025.',
  INIT_CODIGO: '1999/01/01',
  END_CODIGO: '2010/12/31',
  INIT_CODIGO_MINOR: '2011/01/01',
  END_CODIGO_MINOR: '2025/12/31',
  MAYOR_16: '2008/12/31',
  MINOR_120: '1900/01/01',
});

export {Dates2026, Dates2025};
